import { localStorage } from '@play-co/browser-storage';
import StateObserver from 'src/StateObserver';
import { mayHaveCurrentVisitors } from 'src/replicant/visit/visit.getters';

// Set when a login fails to search for or kick this user's visitors, until a later login succeeds.
// The next login moves `previousSessionAt` past the visits that search was meant to find, so only
// this flag gets them searched again.
const visitorKickPendingKey = 'visitorKickPending';

/**
 * Kick any players currently visiting the logged-in player's pet.
 */
export function kickCurrentVisitors() {
  const { user } = StateObserver.getState();

  if (!mayHaveCurrentVisitors(user) && !hasVisitorKickPending(user.id)) {
    return;
  }

  StateObserver.replicant.asyncGetters
    .getCurrentVisitors(user.id)
    .then(async (visitors) => {
      if (visitors.length) {
        await StateObserver.invoke.kickVisitors(visitors);
      }
      setVisitorKickPending(user.id, false);
    })
    .catch((e) => {
      setVisitorKickPending(user.id, true);
      console.warn('Kicking current visitors failed', e);
    });
}

function hasVisitorKickPending(userId: string) {
  return localStorage.getItem(visitorKickPendingKey) === userId;
}

function setVisitorKickPending(userId: string, pending: boolean) {
  if (!pending) {
    localStorage.removeItem(visitorKickPendingKey);
    return;
  }

  try {
    localStorage.setItem(visitorKickPendingKey, userId);
  } catch {
    // A full storage quota still keeps the flag for this session.
  }
}
